<div class="ese-header-action-btns-wrapper"
  [ngClass]="{'ese-header-action-btns-wrapper-vendor-listing': isFromVendorListing || isCreateFromTemplate, 'ese-header-settings-with-scroll' : !isFromVendorListing && questions.length > 5, 'ese-header-vendor-list-with-scroll': isFromVendorListing && questions.length > 4,'ese-header-create-from-template-with-scroll' : isCreateFromTemplate && questions.length > 3} ">
  <div class="form-container" *ngIf="isFromVendorListing || isCreateFromTemplate">
    <div class="form-container-wrapper">
      <div class="event-name-container">
        <div class="text-label lato-16-n-vw text-white">Event Name:</div>
        <input type="text" class="input-field lato-16-n-vw" (input)="eventNameChanged($event)">
      </div>
      <div class="due-date-popup" *ngIf="isShowDueDateCalendar" #dueDatePopup
        [ngClass]="{'due-date-popup-create-from-template': isCreateFromTemplate}"
        (click)="$event.stopPropagation()">
        <div class="deadline-calendar">
          <cygov-ngb-calendar [(selectedDate)]="selectedDueDate"
            (selectedDateChange)="selectedDueDateChangeFunc($event)" [dateType]="'deadlineDateEdit'"
            [inputMinDate]="tomorrowDate" [toggleButton]="false" [openDefault]="true"
            [showDateLabel]="false" [dateToShow]="selectedDueDate" [firstDayOfWeek]="7">
          </cygov-ngb-calendar>
        </div>
      </div>
      <div class="due-date-container">
        <div class="text-label lato-16-n-vw text-white">Due Date:</div>
        <div class="field-with-icon">
          <input type="text" class="input-field due-date lato-16-n-vw" [(ngModel)]="eventDueDate">
          <div class="calendar-icon" #calendarIcon cygovSvgIcon [svgName]="'calendar-icon'"
            (click)="isShowDueDateCalendar = !isShowDueDateCalendar"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="action-btns-container">
    <input type="file" #fileInput style="display: none;" (change)="onFileSelected($event)"
      accept=".xls,.xlsx" />
    <div class="download-template-icon"
      *ngIf="!isFromVendorListing && !isCreateFromTemplate && !isEditMode" cygovSvgIcon
      [svgName]="'download-exfiles-icon-white'" [ngbTooltip]="'Downlaod Template'"
      [placement]="'top'" tooltipClass="uplload-downlaod-temaplate-tooltip"
      (click)="download.emit()">
    </div>

    <div *ngIf="questions.length" class="delete-icon" cygovSvgIcon [svgName]="'trash-icon4'"
      [ngClass]="{'disabled': disableDelete}" (click)="delete.emit()">
    </div>
    <div class=" save-button" *ngIf="isEditMode">
      <cygov-button [buttonText]="'SAVE'" [buttonWidth]="'5.2vw'" [buttonHeight]="'3.2vh'"
        [buttonColor]="'#29a9eb'" [hoverColor]="'#0F92E3'" [textSize]="'14'"
        (click)="save.emit(); saveButtonClicked.emit()">
      </cygov-button>
    </div>
    <div class="edit-icon" cygovSvgIcon [svgName]="isEditMode ? 'x-icon-type2' : 'edit-icon'"
      *ngIf="questions.length" (click)="enableEdit.emit(!isEditMode)">
    </div>
    <!-- <cygov-button class="add-btn" *ngIf="isCreateFromTemplate" [buttonText]="'+'"
      [buttonWidth]="'1vw'" [buttonHeight]="'2vh'" [buttonColor]="'#29a9eb'"
      [hoverColor]="'#0F92E3'" [textSize]="'14'" (click)="addQuestion.emit()">
    </cygov-button> -->

  </div>
</div>

<ng-template #eseTemplateHeader>
  <!-- Empty for filters -->
</ng-template>

<ng-template #eseTemplateContent>
  <div
    class='d-flex justify-content-center align-items-center flex-column confirm-filter-popup-content'>
    <span class='lato-20-n-vw text-white text-center'>Please note, you are about to create a <br>
      new
      questionnaire from a template, which will <br> override and erase the existing one.
    </span>
  </div>
</ng-template>

<ng-template #eseTemplateFooter>
  <div class='external-scan-request-acknowledgement-footer d-flex justify-content-center'>
    <cygov-button class='lato-14-n-vw' [buttonText]="'CONFIRM'" [buttonWidth]="'5vw'"
      [textSize]="'14'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
      [buttonHeight]="'2.963vh'" (click)="onUploadClick()"></cygov-button>
    <cygov-button class="button-margin" [buttonText]="'CANCEL'" [buttonColor]="'#030715'"
      [buttonBorder]="'#C5C9D1'" [buttonWidth]="'5vw'" [textColor]="'#C5C9D1'"
      (click)="closeModal()">
    </cygov-button>
  </div>
</ng-template>